@let details = featureDetails();
@if (details) {
  @for(detail of details.details; track $index) {
    @let columnNames = getColumnKeys(detail);
    <h3>{{ detail.name }}</h3>
    <mat-table [dataSource]="detail.attributes">
      @for (col of detail.columns; track $index) {
        <ng-container matColumnDef="{{col.key}}">
          <mat-header-cell *matHeaderCellDef>
            <span [title]="col.label">{{col.label}}</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let currRow">
            <div class="cell-content" [title]="currRow[col.key]">{{currRow[col.key]}}</div>
          </mat-cell>
        </ng-container>
      }
      <mat-header-row *matHeaderRowDef="columnNames"></mat-header-row>
      <mat-row *matRowDef="let idx = index; columns: columnNames;" [class.even_row]="idx % 2 === 1"></mat-row>
    </mat-table>
  }
}

